var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
    },
    scopedSlots: _vm._u([
      {
        key: "cell(license)",
        fn: function (data) {
          return [
            data.item.license.is_approved
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Approved"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("Not Approved"),
                ]),
            _vm._v(" "),
            _c("b-badge", { attrs: { variant: "info" } }, [
              _vm._v(
                "Packages Last Polled: " + _vm._s(data.item.last_polled_at)
              ),
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0 mt-1" }, [
              _vm._v(_vm._s(data.item.license.number)),
            ]),
            _vm._v(
              "\n      Type: " + _vm._s(data.item.license_type) + "\n      "
            ),
            data.item.license_issued
              ? [
                  _c("br"),
                  _vm._v(
                    "\n        Issued: " +
                      _vm._s(data.item.license_issued) +
                      "\n      "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            data.item.license_expires
              ? [
                  _c("br"),
                  _vm._v(
                    "\n        Expires: " +
                      _vm._s(data.item.license_expires) +
                      "\n      "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "no-permission-wrapper",
                  { attrs: { show: !_vm.canResyncLicenses } },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "primary",
                          size: "xs",
                          disabled: !_vm.canResyncLicenses,
                        },
                        on: {
                          click: () =>
                            _vm.onClickResyncLicense(
                              data.item.license,
                              "packages"
                            ),
                        },
                      },
                      [_vm._v("\n            Resync Packages\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "primary",
                          size: "xs",
                          disabled: !_vm.canResyncLicenses,
                        },
                        on: {
                          click: () =>
                            _vm.onClickResyncLicense(
                              data.item.license,
                              "transfers"
                            ),
                        },
                      },
                      [_vm._v("\n            Resync Transfers\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "cell(company)",
        fn: function (data) {
          return [
            _c(
              "b-link",
              {
                attrs: {
                  to: {
                    name: "admin-company",
                    params: { id: data.item.company.id },
                  },
                },
              },
              [_vm._v(_vm._s(data.item.company.name))]
            ),
          ]
        },
      },
      {
        key: "cell(facility)",
        fn: function (data) {
          return [
            _c("strong", [_vm._v(_vm._s(data.item.license.facility.name))]),
            _vm._v(" "),
            data.item.facility_street_address
              ? [
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(data.item.facility_street_address) +
                      "\n      "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            data.item.facility_city_address
              ? [
                  _c("br"),
                  _vm._v(
                    "\n        " +
                      _vm._s(data.item.facility_city_address) +
                      "\n      "
                  ),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(permissions)",
        fn: function (data) {
          return [
            data.item.license.is_to_buy
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Purchases"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("No Purchases"),
                ]),
            _vm._v(" "),
            data.item.license.is_to_sell
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Sales"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("No Sales"),
                ]),
          ]
        },
      },
      {
        key: "cell(actions)",
        fn: function (data) {
          return [
            _c(
              "no-permission-wrapper",
              { attrs: { show: !_vm.canUpdateLicenses } },
              [
                !data.item.license.is_approved
                  ? _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "success",
                          disabled: !_vm.canUpdateLicenses,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() =>
                              _vm.onClickApproveLicense(
                                data.item.license
                              )).apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          Approve\n        ")]
                    )
                  : _c(
                      "b-btn",
                      {
                        attrs: {
                          variant: "danger",
                          disabled: !_vm.canUpdateLicenses,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return (() =>
                              _vm.onClickDisapproveLicense(
                                data.item.license
                              )).apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n          Disapprove\n        ")]
                    ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }